<template>
  <div class="page-content free-study-page">
    <div class="content-wrap" v-loading="pageLoading">
        <div class="page-header d-flex d-flex-between d-flex-middle">
          <div class="page-title d-flex d-flex-middle">
            <span class="title-bar"></span>
            <span class="title-text">专业计划</span>
          </div>
          <a href="javascript:void(0)" class="back-link" @click="handleBack">
            <i class="el-icon-back"></i> 返回
          </a>
        </div>
        <div class="course-info-card">
          <div class="course-header-row">
            <div class="course-icon" aria-hidden="true">
              <i class="el-icon-reading"></i>
            </div>
            <p class="course-title">{{ courseInfo.courseCode + ' - ' + courseInfo.courseName }}</p>
          </div>
          <div class="course-meta">
            <span class="meta-item">
              <span class="meta-label">课程类型：</span>
              <span class="meta-value">{{ courseInfo.courseTypeName || '' }}</span>
            </span>
            <span class="meta-item">
              <span class="meta-label">学分：</span>
              <span class="meta-value">{{ courseInfo.score || 0 }}</span>
            </span>
            <span class="meta-item">
              <span class="meta-label">课件：</span>
              <span class="meta-value">{{ courseInfo.chapterCount || 0 }}章{{ courseInfo.totalLessons || 0 }}节</span>
            </span>
            <span class="meta-item meta-item--link" @click="openWrongModal">
              <span class="meta-label">错题集：</span>
              <span class="meta-value meta-value--danger">{{ courseInfo.wrongCount || 0 }}题</span>
            </span>
            <span class="meta-item meta-item--link" @click="openFavModal">
              <span class="meta-label">收藏夹：</span>
              <span class="meta-value meta-value--accent">{{ courseInfo.favCount || 0 }}题</span>
            </span>
          </div>
        </div>

        <div class="study-tabs">
          <div class="tab" :class="{ active: activeTab === 'video' }" @click="switchStudyTab('video')">
            <span class="tab-label">课件学习</span>
          </div>
          <div class="tab" :class="{ active: activeTab === 'paper' }" @click="switchStudyTab('paper')">
            <span class="tab-label">题库练习</span>
          </div>
        </div>

        <div class="tab-content" v-show="activeTab === 'video'">
          <div class="video-area" v-if="courseInfo.coursewareId">
            <div
              class="video-player"
              :class="{
                dis: hideVideoProgress,
                'video-progress-always': videoProgressAlwaysVisible,
              }"
            >
              <video ref="videoBoxRef" id="freeVideoPlayer" class="video-js vjs-fluid vjs-big-play-centered"
                style="width: 100%; height: 100%;" controls preload="auto" autoplay :loop="false"></video>
            </div>
            <div class="chapter-sidebar">
              <div class="sidebar-tabs">
                <div class="sidebar-tab" :class="{ active: videoSideTab === 1 }" @click="videoSideTab = 1">目录</div>
                <div class="sidebar-tab" :class="{ active: videoSideTab === 2 }" @click="videoSideTab = 2">留言</div>
              </div>
              <div class="sidebar-tab-panel" v-show="videoSideTab === 1">
                <div class="chapter" v-for="(chapter, ci) in chapterList" :key="ci">
                  <div
                    class="chapter-name"
                    :class="{ expanded: chapter.expanded }"
                    @click="toggleChapter(ci)"
                  >
                    <span class="chapter-title">
                      <span class="chapter-no">{{ formatChapterNo(ci) }}</span>
                      <span class="chapter-label">{{ chapter.name }}</span>
                    </span>
                    <span class="chapter-arrow" :class="{ open: chapter.expanded }">
                      <img src="@/assets/freeStudy_bottom.png" alt="" class="arrow">
                    </span>
                  </div>
                  <div class="lessons" v-show="chapter.expanded">
                    <div
                      class="lesson"
                      :class="{ active: currentLessonIndex === li && currentChapterIndex === ci }"
                      v-for="(lesson, li) in chapter.lessons"
                      :key="li"
                      @click="selectLesson(ci, li)"
                    >
                      <span class="lesson-icon" aria-hidden="true">
                        <img
                          :src="currentLessonIndex === li && currentChapterIndex === ci
                            ? require('@/assets/freeStudy_playing.png')
                            : require('@/assets/freeStudy_play.png')"
                          alt=""
                        >
                      </span>
                      <span class="lesson-name">
                        {{ lesson.name }}{{ formatLessonProgress(lesson) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sidebar-tab-panel sidebar-tab-panel--qa" v-show="videoSideTab === 2">
                <div class="qa-comment">
                  <div v-if="!commentList.length" class="qa-empty">
                    <i class="el-icon-chat-dot-round qa-empty-icon" aria-hidden="true"></i>
                    <p class="qa-empty-title">还没有留言</p>
                    <p class="qa-empty-hint">有问题可在下方输入，教师会看到并回复</p>
                  </div>
                  <article
                    v-for="(item, idx) in commentList"
                    :key="item.id || idx"
                    class="qa-thread"
                  >
                    <div class="qa-row">
                      <div
                        class="qa-avatar qa-avatar--root"
                        :aria-label="commentAuthorLabel(item)"
                      >
                        {{ qaAvatarInitial(commentAuthorLabel(item)) }}
                      </div>
                      <div class="qa-body">
                        <header class="qa-head">
                          <div class="qa-head-left">
                            <span class="qa-nick qa-nick--student">{{ commentAuthorLabel(item) }}</span>
                            <span class="qa-badge-lv qa-badge-lv--stu">学员</span>
                          </div>
                          <time class="qa-time">{{ item.createTime }}</time>
                        </header>
                        <p class="qa-content">{{ item.content }}</p>
                      </div>
                    </div>
                    <div v-if="sortedReplies(item).length" class="qa-reply-wrap">
                      <div
                        v-for="rep in sortedReplies(item)"
                        :key="rep.id"
                        class="qa-row qa-row--reply"
                      >
                        <div
                          class="qa-avatar qa-avatar--reply"
                          :aria-label="rep.teacher || '教师'"
                        >
                          {{ qaAvatarInitial(rep.teacher || '教') }}
                        </div>
                        <div class="qa-body">
                          <header class="qa-head">
                            <div class="qa-head-left">
                              <span class="qa-nick qa-nick--teacher">{{ rep.teacher || '教师' }}</span>
                              <span class="qa-badge-lv qa-badge-lv--teacher">教师</span>
                            </div>
                            <time class="qa-time">{{ rep.createTime }}</time>
                          </header>
                          <p class="qa-content">{{ rep.content }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="item.replyName" class="qa-reply-wrap">
                      <div class="qa-row qa-row--reply">
                        <div class="qa-avatar qa-avatar--reply" :aria-label="item.replyName">
                          {{ qaAvatarInitial(item.replyName) }}
                        </div>
                        <div class="qa-body">
                          <header class="qa-head">
                            <div class="qa-head-left">
                              <span class="qa-nick qa-nick--teacher">{{ item.replyName }}</span>
                              <span class="qa-badge-lv qa-badge-lv--teacher">教师</span>
                            </div>
                            <time class="qa-time">{{ item.replyTime }}</time>
                          </header>
                          <p class="qa-content">{{ item.replyContent }}</p>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
                <div class="qa-compose">
                  <el-input
                    class="qa-compose-inp"
                    size="small"
                    v-model="commentContent"
                    placeholder="输入留言内容…"
                    clearable
                    @keyup.enter.native="handleCommentSubmit"
                  />
                  <el-button
                    class="qa-compose-btn"
                    type="primary"
                    size="small"
                    @click="handleCommentSubmit"
                  >
                    发送
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <el-empty description="暂无课件" v-else></el-empty>
        </div>

        <div class="tab-content" v-show="activeTab === 'paper'">
          <div class="paper-area" v-if="paperList.length > 0">
            <ul class="paper-list">
              <li class="paper-item" v-for="(paper, pi) in paperList" :key="pi">
                <div class="paper-info">
                  <p class="paper-name">{{ paper.name }}</p>
                  <div class="paper-meta">
                    <span class="paper-meta-item">
                      <span class="meta-label">题量：</span>
                      <span class="meta-value">{{ (paper.currentAnsweredCount != null ? paper.currentAnsweredCount : 0) }}/{{ paper.questionCount }}题</span>
                    </span>
                    <span class="paper-meta-item">
                      <span class="meta-label">练习：</span>
                      <a
                        v-if="paper.practiceCount"
                        href="javascript:void(0);"
                        class="meta-value meta-value--link"
                        @click="viewPaperRecord(paper)"
                      >{{ paper.practiceCount }}次</a>
                      <span v-else class="meta-value">--</span>
                    </span>
                    <span class="paper-meta-item">
                      <span class="meta-label">客观题正确率：</span>
                      <span class="meta-value">{{ paper.lastRecord && paper.lastRecord.correctRate != null ? paper.lastRecord.correctRate + '%' : '--' }}</span>
                    </span>
                    <span class="paper-meta-item">
                      <span class="meta-label">最近练习时间：</span>
                      <span class="meta-value">{{ (paper.lastRecord && paper.lastRecord.time) || '--' }}</span>
                    </span>
                  </div>
                </div>
                <div class="paper-actions">
                  <button
                    v-if="paper.canContinue"
                    class="paper-btn ing"
                    @click="continuePaper(paper)"
                  >继续练习</button>
                  <button
                    v-else
                    class="paper-btn"
                    @click="openModeDialog(paper)"
                  >开始练习</button>
                </div>
              </li>
            </ul>
          </div>
          <el-empty description="暂无试题" v-else></el-empty>
        </div>
    </div>

    <div class="confirm-overlay" v-if="confirmVisible" @click.self="closeConfirm">
      <div class="confirm-box">
        <div class="confirm-icon warn">⚠</div>
        <p class="confirm-title">{{ confirmTitle }}</p>
        <p class="confirm-desc">{{ confirmDesc }}</p>
        <div class="confirm-actions">
          <button class="btn btn-cancel" @click="closeConfirm">取消</button>
          <button class="btn btn-danger" @click="doConfirm">确定</button>
        </div>
      </div>
    </div>

    <WrongModal :visible.sync="wrongModalVisible" :courseId="courseId" @deleted="getCourseInfo" />
    <FavModal :visible.sync="favModalVisible" :courseId="courseId" @deleted="getCourseInfo" />

    <div class="mode-overlay" v-if="modeDialogVisible" @click.self="closeModeDialog">
      <div class="mode-dialog" @click.stop>
        <div class="mode-dialog-header">
          <div class="md-title">选择练习模式</div>
          <span class="md-close" @click="closeModeDialog">&times;</span>
        </div>
        <div class="md-options">
          <div
            class="md-opt"
            :class="{ active: selectedMode === 'answer' }"
            @click="selectedMode = 'answer'"
          >
            <img src="@/assets/freestudy_dt.png" alt="" class="md-icon-img" />
            <div class="md-text">
              <div class="md-name">答题模式</div>
              <div class="md-desc">模拟真实考试，检验学习成果</div>
            </div>
          </div>
          <div
            class="md-opt"
            :class="{ active: selectedMode === 'back' }"
            @click="selectedMode = 'back'"
          >
            <img src="@/assets/freestudy_bt.png" alt="" class="md-icon-img" />
            <div class="md-text">
              <div class="md-name">背题模式</div>
              <div class="md-desc">直接查看答案，快速记忆知识点</div>
            </div>
          </div>
        </div>
        <div class="md-actions">
          <button type="button" class="md-btn md-btn-cancel" @click="closeModeDialog">取消</button>
          <button type="button" class="md-btn md-btn-confirm" @click="confirmMode">确定</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import WrongModal from "./components/WrongModal.vue";
import FavModal from "./components/FavModal.vue";
import videojs from "video.js";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "videojs-flvjs-es6";

/** 每累计多少秒「有效播放」上报一次（由定时器在播放中累加，与视频 currentTime 无关） */
const ACHIEVE_PLAYBACK_SEC = 60;
/** 定时器步长（毫秒），与累加秒数一致：每 tick 增加 1 秒播放量 */
const ACHIEVE_TICK_MS = 1000;
/**
 * 视频进度条是否始终显示。
 * true  - 始终显示进度条，控制栏不自动隐藏
 * false - 未学完的课隐藏进度条（禁止拖动，与 courseStudy.vue 一致）
 */
const VIDEO_PROGRESS_ALWAYS_VISIBLE = true;

export default {
  name: "courseDetail",
  components: {
    WrongModal,
    FavModal,
  },
  data() {
    return {
      courseId: '',
      activeTab: 'video',
      courseInfo: {},
      chapterList: [],
      currentChapterIndex: -1,
      currentLessonIndex: -1,
      currentLesson: {},
      videoPlayer: null,
      /** 自上次成功上报以来累计的有效播放秒数（仅播放中由定时器增加） */
      achievePlaybackAccumSec: 0,
      achieveRequestInFlight: false,
      /** setInterval 句柄；启动前必须先 clear，避免重复计时 */
      achievePlaybackIntervalId: null,
      /** 进入页面恢复上次学习进度后提示续播 */
      pendingResumeTip: false,
      paperList: [],
      wrongModalVisible: false,
      favModalVisible: false,
      modeDialogVisible: false,
      selectedMode: 'answer',
      pendingPaper: null,
      confirmVisible: false,
      confirmTitle: '',
      confirmDesc: '',
      confirmCallback: null,
      pageLoading: false,
      videoSideTab: 1,
      commentContent: '',
      commentList: [],
    };
  },
  computed: {
    /** 未学完课时是否隐藏进度条（由 VIDEO_PROGRESS_ALWAYS_VISIBLE 控制） */
    hideVideoProgress() {
      return !VIDEO_PROGRESS_ALWAYS_VISIBLE
        && this.currentLesson.id
        && !this.currentLesson.isFinished;
    },
    videoProgressAlwaysVisible() {
      return VIDEO_PROGRESS_ALWAYS_VISIBLE;
    },
  },
  created() {
    this.courseId = this.$route.query.courseId;
    if (!this.courseId) {
      this.$message.warning('课程参数缺失，即将返回');
      this.$router.replace('/main/specialtyPlan');
      return;
    }
    this.getCourseInfo();
    this.getPaperList();
  },
  /** 同一路由仅 query（如 courseId）变化时会复用实例，created 不会再次执行 */
  beforeRouteUpdate(to, from, next) {
    const nextId = to.query.courseId;
    if (nextId && String(nextId) !== String(this.courseId)) {
      this.courseId = nextId;
      this.chapterList = [];
      this.currentChapterIndex = -1;
      this.currentLessonIndex = -1;
      this.currentLesson = {};
      this.courseInfo = {};
      this.commentList = [];
      this.clearAchieveSchedule();
      this.disposeVideoPlayer();
      this.getCourseInfo();
      this.getPaperList();
    }
    next();
  },
  destroyed() {
    this.disposeVideoPlayer();
    this.clearAchieveSchedule();
  },
  methods: {
    handleBack() {
      this.$router.push('/main/specialtyPlan');
    },
    getCourseInfo() {
      this.pageLoading = true;
      this.$http.get('/student/pc/freeStudy/courseInfo', { courseId: this.courseId }).then(res => {
        if (res) {
          this.courseInfo = res;
          if(res.coursewareId){
            this.getChapterList();
            this.getComment();
          }
        }
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    getChapterList() {
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      if (!coursewareId) {
        this.chapterList = [];
        return;
      }
      this.$http.get('/student/pc/freeStudy/chapters', { coursewareId }).then(res => {
        if (!Array.isArray(res)) {
          this.chapterList = [];
          return;
        }
        this.chapterList = res.map((chapter) => ({
          ...chapter,
          expanded: false,
          lessons: (chapter.lessons || []).map(lesson => ({
            ...lesson,
            minutes: lesson.minutes || lesson.totalDuration || 0,
            isFinished: !!lesson.isFinished,
          })),
        }));
        // 等章节列表渲染后再选节，避免 #freeVideoPlayer 尚未挂载时 initVideo 取不到节点
        this.$nextTick(() => {
          this.setLive();
        });
      });
    },
    setLive() {
      if (!this.chapterList || !this.chapterList.length) {
        return;
      }
      const lastStudy = this.findLessonWithLastDuration();
      if (lastStudy) {
        this.pendingResumeTip = this.getLessonResumeSeconds(lastStudy.lesson) > 0;
        this.toggleChapter(lastStudy.ci, true);
        this.selectLesson(lastStudy.ci, lastStudy.li);
        return;
      }
      const picked = this.chapterList.some((z, zi) => {
        return (z.lessons || []).some((j, ji) => {
          if (!j.isFinished) {
            this.toggleChapter(zi, true);
            this.selectLesson(zi, ji);
            return true;
          }
          return false;
        });
      });
      // 全部标记已学完时也要默认选中第一节，否则播放器无源、用户误以为 setLive 未执行
      if (!picked) {
        const first = this.chapterList[0];
        const lessons = first && first.lessons;
        if (lessons && lessons.length) {
          this.toggleChapter(0, true);
          this.selectLesson(0, 0);
        }
      }
    },
    getPaperList() {
      this.$http.get('/student/pc/freeStudy/papers', { courseId: this.courseId }).then(res => {
        if (res) {
          this.paperList = res || [];
        }
      });
    },
    toggleChapter(index, forceOpen) {
      this.$set(this.chapterList[index], 'expanded', forceOpen || !this.chapterList[index].expanded);
    },
    formatChapterNo(index) {
      const n = index + 1;
      const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      if (n <= 0) return '';
      if (n < 10) return `第${digits[n]}章`;
      if (n === 10) return '第十章';
      if (n < 20) return `第十${digits[n - 10]}章`;
      return `第${n}章`;
    },
    /** 在 chapters 接口返回中查找带 lastDuration 的课节（仅会出现在某一节） */
    findLessonWithLastDuration() {
      for (let ci = 0; ci < this.chapterList.length; ci++) {
        const lessons = this.chapterList[ci].lessons || [];
        for (let li = 0; li < lessons.length; li++) {
          const lesson = lessons[li];
          if (lesson.lastDuration != null && Number(lesson.lastDuration) > 0) {
            return { ci, li, lesson };
          }
        }
      }
      return null;
    },
    formatLessonProgress(lesson) {
      const learned = Math.floor(Number(lesson && lesson.duration) || 0);
      const total = Math.floor(Number(lesson && lesson.minutes) || 0);
      return ` (${learned}/${total}分钟)`;
    },
    getVideoFormatRegex(url) {
      const flvRegex = /\.(flv)$/i;
      const m3u8Regex = /\.(m3u8)$/i;
      if (flvRegex.test(url)) {
        return 'video/x-flv';
      } else if (m3u8Regex.test(url)) {
        return 'application/x-mpegURL';
      } else {
        return '';
      }
    },
    selectLesson(chapterIndex, lessonIndex) {
      // 仅当已是当前节且播放器已就绪时才跳过；避免 videoPlayer 已 dispose 或尚未 init 时误跳过
      if (
        this.currentChapterIndex === chapterIndex &&
        this.currentLessonIndex === lessonIndex &&
        this.videoPlayer
      ) {
        return;
      }
      this.clearAchieveSchedule();
      this.currentChapterIndex = chapterIndex;
      this.currentLessonIndex = lessonIndex;
      this.currentLesson = this.chapterList[chapterIndex].lessons[lessonIndex];
      const src = this.currentLesson.filePath;
      if (src) {
        this.initVideo(src, this.getVideoFormatRegex(src));
      }
    },
    /** 切换视频后起播位置（秒）：有 lastDuration 则按分钟换算，否则从已学 duration（分钟）换算 */
    getLessonResumeSeconds(lesson) {
      if (!lesson) {
        return 0;
      }
      if (lesson.lastDuration != null && Number(lesson.lastDuration) > 0) {
        return Math.floor(Number(lesson.lastDuration) * 60);
      }
      if (lesson.isFinished) {
        return 0;
      }
      const m = Number(lesson.duration);
      if (!m || m <= 0) {
        return 0;
      }
      return m * 60;
    },
    /**
     * 将播放进度跳到当前课续播秒数。
     * HLS 常在 canplay/loadeddata 后才能真正 seek；若 metadata 已先于监听触发，需立即尝试 + 延时重试。
     */
    seekToLessonResume(player, startSec) {
      if (!player || startSec <= 0) {
        return;
      }
      let resumeTipShown = false;
      const showResumeTipOnce = () => {
        if (resumeTipShown || !this.pendingResumeTip) {
          return;
        }
        resumeTipShown = true;
        this.pendingResumeTip = false;
        // this.$message.info(`上次观看到 ${this.formatTime(startSec)}，已自动跳转`);
      };
      const trySeek = () => {
        if (!this.videoPlayer || this.videoPlayer !== player) {
          return false;
        }
        try {
          const d = player.duration();
          if (!Number.isFinite(d) || d <= 0) {
            return false;
          }
          const target = startSec > d ? Math.max(0, d - 0.5) : startSec;
          if (Math.abs(player.currentTime() - target) < 1) {
            showResumeTipOnce();
            return true;
          }
          player.currentTime(target);
          if (Math.abs(player.currentTime() - target) < 2) {
            showResumeTipOnce();
            return true;
          }
        } catch (e) {
          /* seekable 未就绪，交给后续重试 */
        }
        return false;
      };
      const scheduleSeek = () => {
        if (trySeek()) {
          return;
        }
        player.one('loadedmetadata', trySeek);
        player.one('durationchange', trySeek);
        player.one('loadeddata', trySeek);
        player.one('canplay', trySeek);
        player.one('canplaythrough', trySeek);
        player.one('playing', () => {
          if (startSec > 0 && player.currentTime() < 1) {
            trySeek();
          }
        });
        [120, 400, 800, 1200, 2000, 3000].forEach((delay) => {
          setTimeout(trySeek, delay);
        });
      };
      scheduleSeek();
    },
    initVideo(src, type) {
      src = src.replace('http://', 'https://');
      const _this = this;
      const startSec = _this.getLessonResumeSeconds(_this.currentLesson);
      if (this.videoPlayer) {
        if (startSec > 0) {
          _this.seekToLessonResume(_this.videoPlayer, startSec);
        }
        this.videoPlayer.src({ src, type });
        this.videoPlayer.load();
        return;
      }
      this.$nextTick(() => {
        const options = {
          height: 530,
          ...(VIDEO_PROGRESS_ALWAYS_VISIBLE ? { inactivityTimeout: 0 } : {}),
          fullscreen: {
            options: { navigationUI: "hide" },
          },
          techOrder: ["html5", "flvjs"],
          html5: {
            hls: {
              withCredentials: true,
            },
          },
          flvjs: {
            mediaDataSource: {
              isLive: false,
              cors: true,
              withCredentials: false,
            },
          },
          sources: [{ src, type }],
        };
        const videoElement = document.getElementById('freeVideoPlayer');
        _this.videoPlayer = videojs(videoElement, options, function onPlayerReady() {
          _this.videoPlayer.on('play', function () {
            _this.startAchievePlaybackTicker();
          });
          _this.videoPlayer.on('pause', function () {
            _this.stopAchievePlaybackTicker();
          });
          _this.videoPlayer.on('ended', function () {
            _this.clearAchieveSchedule();
            _this.onEnded();
          });
        });
        // 须在 onPlayerReady 之前注册续播，避免 loadedmetadata 先触发导致错过
        if (startSec > 0) {
          _this.seekToLessonResume(_this.videoPlayer, startSec);
        }
      });
    },
    onEnded() {
      this.setLive();
    },
    switchStudyTab(tab) {
      if (this.activeTab === tab) {
        return;
      }
      if (this.activeTab === 'video') {
        this.pauseVideoStudy();
        this.saveLastDuration();
      }
      this.activeTab = tab;
    },
    /** 离开课件 tab 时暂停播放并停止有效播放计时（保留已累计秒数，与手动暂停一致） */
    pauseVideoStudy() {
      this.stopAchievePlaybackTicker();
      const player = this.videoPlayer;
      if (!player) {
        return;
      }
      try {
        if (!player.paused()) {
          player.pause();
        }
      } catch (e) {
        /* ignore */
      }
    },
    clearAchieveSchedule() {
      this.stopAchievePlaybackTicker();
      this.achievePlaybackAccumSec = 0;
      this.achieveRequestInFlight = false;
    },
    stopAchievePlaybackTicker() {
      if (this.achievePlaybackIntervalId != null) {
        clearInterval(this.achievePlaybackIntervalId);
        this.achievePlaybackIntervalId = null;
      }
    },
    /** 仅在播放中运行；启动前会清掉旧 interval，避免重复 */
    startAchievePlaybackTicker() {
      this.stopAchievePlaybackTicker();
      if (!this.currentLesson || this.currentLesson.isFinished) {
        return;
      }
      const self = this;
      this.achievePlaybackIntervalId = setInterval(() => {
        self.onAchieveIntervalTick();
      }, ACHIEVE_TICK_MS);
    },
    onAchieveIntervalTick() {
      const v = this.videoPlayer;
      if (!v || v.paused()) {
        return;
      }
      if (!this.currentLesson || this.currentLesson.isFinished) {
        this.stopAchievePlaybackTicker();
        return;
      }
      this.achievePlaybackAccumSec += ACHIEVE_TICK_MS / 1000;
      const total = this.achievePlaybackAccumSec;
      const need = Math.max(0, ACHIEVE_PLAYBACK_SEC - total);
      //
      // console.log(
      //   '[freeStudy achieve] 定时器 +1s | 累计有效播放:',
      //   `${total.toFixed(1)}s`,
      //   '| 距满',
      //   `${ACHIEVE_PLAYBACK_SEC}s 上报还差:`,
      //   need > 0 ? `${need.toFixed(1)}s` : '已达阈值，将触发上报',
      // );
      this.tryFlushAchievePlayback();
    },
    tryFlushAchievePlayback() {
      if (!this.videoPlayer || !this.currentLesson || this.currentLesson.isFinished) {
        return;
      }
      if (this.achieveRequestInFlight) {
        return;
      }
      if (this.achievePlaybackAccumSec < ACHIEVE_PLAYBACK_SEC) {
        return;
      }
      // eslint-disable-next-line no-console
      // console.log(
      //   '[freeStudy achieve] 发起 videoProgress | 累计:',
      //   `${this.achievePlaybackAccumSec.toFixed(1)}s`,
      //   '| 阈值:',
      //   `${ACHIEVE_PLAYBACK_SEC}s`,
      // );
      this.achieveRequestInFlight = true;
      this.achieve()
        .then((res) => {
          if (!this.currentLesson || this.currentLesson.isFinished) {
            return;
          }
          if (res) {
            const before = this.achievePlaybackAccumSec;
            this.achievePlaybackAccumSec = Math.max(0, this.achievePlaybackAccumSec - ACHIEVE_PLAYBACK_SEC);
            // eslint-disable-next-line no-console
            // console.log(
            //   '[freeStudy achieve] 上报成功，扣减',
            //   `${ACHIEVE_PLAYBACK_SEC}s | 扣减前:`,
            //   `${before.toFixed(1)}s`,
            //   '→ 扣减后:',
            //   `${this.achievePlaybackAccumSec.toFixed(1)}s`,
            // );
          }
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          // console.warn('[freeStudy achieve] 上报失败，累计不扣减，当前:', `${this.achievePlaybackAccumSec.toFixed(1)}s`);
        })
        .finally(() => {
          this.achieveRequestInFlight = false;
          if (!this.currentLesson || this.currentLesson.isFinished) {
            return;
          }
          if (this.achievePlaybackAccumSec >= ACHIEVE_PLAYBACK_SEC) {
            this.$nextTick(() => this.tryFlushAchievePlayback());
          }
        });
    },
    /** 销毁播放器前上报当前播放进度（分钟，取整） */
    saveLastDuration() {
      if (!this.currentLesson || !this.currentLesson.id || !this.videoPlayer) {
        return;
      }
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      const chapter = this.chapterList[this.currentChapterIndex];
      if (!coursewareId || !chapter) {
        return;
      }
      let lastDuration = 0;
      try {
        lastDuration = Math.floor((this.videoPlayer.currentTime() || 0) / 60);
      } catch (e) {
        return;
      }
      this.$http.post_s('/student/pc/freeStudy/lastDuration', {
        coursewareId,
        chapterId: chapter.id,
        lessonId: this.currentLesson.id,
        lastDuration: Math.max(0, lastDuration),
      });
    },
    disposeVideoPlayer() {
      if (!this.videoPlayer) {
        return;
      }
      console.log('xxxxxx');
      this.saveLastDuration();
      try {
        this.videoPlayer.dispose();
      } catch (e) {
        /* ignore */
      }
      this.videoPlayer = null;
    },
    achieve() {
      if (!this.currentLesson || this.currentLesson.isFinished) {
        return Promise.resolve();
      }
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      const chapter = this.chapterList[this.currentChapterIndex];
      if (!coursewareId || !chapter) {
        return Promise.resolve();
      }
      return this.$http.post_s("/student/pc/freeStudy/videoProgress", {
        coursewareId,
        chapterId: chapter.id,
        lessonId: this.currentLesson.id,
      }).then((res) => {
        if (!res) {
          return null;
        }
        const ci = (this.currentLesson.duration || 0) + 1;
        this.$set(this.currentLesson, 'isFinished', !!res.isFinished);
        this.$set(this.currentLesson, 'duration', res.duration || ci);
        if (res.isFinished) {
          this.clearAchieveSchedule();
          this.setLive();
        }
        return res;
      });
    },
    formatTime(seconds) {
      if (!seconds && seconds !== 0) return '0:00';
      const s = Math.floor(seconds);
      const m = Math.floor(s / 60);
      const sec = s % 60;
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    },
    getRateClass(rate) {
      if (rate >= 80) return 'high';
      if (rate >= 60) return 'mid';
      return 'low';
    },
    getRateColor(rate) {
      if (rate >= 80) return '#67c23a';
      if (rate >= 60) return '$accent';
      return '#f56c6c';
    },
    openModeDialog(paper) {
      this.pendingPaper = paper;
      this.selectedMode = 'answer';
      this.modeDialogVisible = true;
    },
    closeModeDialog() {
      this.modeDialogVisible = false;
      this.pendingPaper = null;
      this.selectedMode = 'answer';
    },
    confirmMode() {
      const mode = this.selectedMode;
      if (this.pendingPaper) {
        this.$router.push({
          path: '/main/freeStudyPaper',
          query: {
            paperId: this.pendingPaper.id,
            courseId: this.courseId,
            mode,
          },
        });
      }
      this.closeModeDialog();
    },
    continuePaper(paper) {
      this.$router.push({
        path: '/main/freeStudyPaper',
        query: {
          paperId: paper.id,
          courseId: this.courseId,
          mode: 'answer',
        },
      });
    },
    viewPaperRecord(paper) {
      this.$router.push({
        path: '/main/paperResult',
        query: {
          paperId: paper.id,
          courseId: this.courseId,
        },
      });
    },
    openWrongModal() {
      this.wrongModalVisible = true;
    },
    openFavModal() {
      this.favModalVisible = true;
    },
    showConfirm(title, desc, callback) {
      this.confirmTitle = title;
      this.confirmDesc = desc;
      this.confirmCallback = callback;
      this.confirmVisible = true;
    },
    closeConfirm() {
      this.confirmVisible = false;
      this.confirmCallback = null;
    },
    doConfirm() {
      if (this.confirmCallback) {
        this.confirmCallback();
      }
      this.closeConfirm();
    },
    getComment() {
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      if (!coursewareId) {
        return;
      }
      this.$http.get('/student/pc/freeStudy/interaction/myMessages', { coursewareId }).then((res) => {
        this.commentList = Array.isArray(res) ? res : [];
      });
    },
    /** myMessages：主贴无 studentName 时用「我」；教师回复在 replies 数组内 */
    commentAuthorLabel(item) {
      return item.studentName || '我';
    },
    sortedReplies(item) {
      const list = item && item.replies;
      if (!Array.isArray(list) || !list.length) {
        return [];
      }
      return [...list].sort((a, b) => String(a.createTime || '').localeCompare(String(b.createTime || '')));
    },
    /** 头像内一字（参考评论区样式） */
    qaAvatarInitial(name) {
      const s = String(name || '').trim();
      if (!s) {
        return '?';
      }
      return s.slice(0, 1);
    },
    handleCommentSubmit() {
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      if (!coursewareId) {
        this.$message({
          showClose: true,
          message: '暂无课件，无法发送',
          type: 'error',
        });
        return;
      }
      if (!this.commentContent) {
        this.$message({
          showClose: true,
          message: '内容不能为空',
          type: 'error',
        });
        return;
      }
      this.$http
        .post('/student/pc/freeStudy/interaction/add', {
          coursewareId,
          content: this.commentContent,
        })
        .then(() => {
          this.commentContent = '';
          this.getComment();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.free-study-page { min-height: 639px; }
.content-wrap { width: 100%; overflow: hidden;background: #FFFFFF;box-shadow: 0px 3px 10px 0px rgba(153,153,153,0.25);border-radius: 10px;}
.mianbao { line-height: 30px; padding: 15px 0; }
.mianbao .dq { color: #666; font-size: 14px; }
.mianbao .mba { color: #666; font-size: 14px; padding: 0 5px; text-decoration: none; &:hover { color: $primary-dark; } }
.mianbao .site { color: $primary-dark; font-size: 14px; padding: 0 5px; }

.course-info-card {
  box-sizing: border-box;
  padding: 0 30px;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.course-header-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.course-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f59a23;
  display: flex;
  align-items: center;
  justify-content: center;
  i { color: #fff; font-size: 14px; }
}

.course-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  line-height: 1.3;
}

.course-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 60px;
  font-size: 14px;
  line-height: 1.5;
}

.meta-label { color: #999; }
.meta-value { color: #333; }

.meta-item--link {
  cursor: pointer;
  &:hover .meta-value--danger { color: darken($danger, 8%); }
  &:hover .meta-value--accent { color: darken($accent, 8%); }
}

.meta-value--danger {
  color: #e85d5d;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.meta-value--accent {
  color: $accent;
  text-decoration: underline;
  text-underline-offset: 2px;
}


.study-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  margin: 16px 30px 0;
  padding: 0 24px;
  background: $primary-light;
  border-radius: 8px;
  height: 40px;

  .tab {
    position: relative;
    font-size: 15px;
    line-height: 40px;
    color: #333;
    cursor: pointer;
    transition: color 0.2s;

    &.active {
      color: $primary;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 32px;
        height: 3px;
        border-radius: 2px;
        background: $primary;
      }
    }

    &:hover:not(.active) {
      color: $primary-dark;
    }
  }
}

.tab-content { background: #fff; border-top: none; min-height: 530px;margin-bottom: 30px; }

::v-deep .dis .vjs-progress-control {
  visibility: hidden;
}
::v-deep .video-progress-always .vjs-progress-control {
  visibility: visible !important;
  opacity: 1 !important;
}
.video-area { display: flex;box-sizing: border-box; padding: 20px 30px 0 30px; }
.video-player {
  flex: 1; min-width: 0; height: 530px; background: #262626;
  display: flex; align-items: center; justify-content: center; color: #fff; font-size: 16px; position: relative;
}

.chapter-sidebar {
  width: 320px;
  flex-shrink: 0;
  height: 530px;
  box-sizing: border-box;
  padding: 0 16px 0 20px;
  border-left: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .sidebar-tabs {
    display: flex;
    justify-content: center;
    padding: 10px 0;
    color: #333;
    border-bottom: 1px solid #eaeaea;
    flex-shrink: 0;
  }
  .sidebar-tab {
    flex: 1;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    &.active {
      position: relative;
      color: $primary-dark;
      font-weight: bold;
      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 28px;
        height: 3px;
        background-color: $primary-dark;
      }
    }
  }
  .sidebar-tab-panel {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    position: relative;
    overflow-x: hidden;
  }
  .sidebar-tab-panel--qa {
    display: flex;
    flex-direction: column;
    padding-top: 0;
    overflow: hidden;
    background: linear-gradient(180deg, #f8fafc 0%, #fff 22px);
  }

  .qa-comment {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 13px;
    padding: 8px 4px 14px;
    line-height: 1.5;
    -webkit-overflow-scrolling: touch;
    color: #1e293b;
    scrollbar-width: thin;
  }

  .qa-empty {
    text-align: center;
    padding: 40px 18px 32px;
    margin: 8px 4px 0;
    border-radius: 12px;
    background: linear-gradient(160deg, rgba($primary-dark, 0.04) 0%, #fff 55%);
    border: 1px dashed rgba($primary-dark, 0.12);
    color: #64748b;
  }
  .qa-empty-icon {
    display: block;
    font-size: 40px;
    line-height: 1;
    margin: 0 auto 12px;
    color: rgba($primary-dark, 0.22);
  }
  .qa-empty-title {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
    color: #475569;
    letter-spacing: 0.02em;
  }
  .qa-empty-hint {
    margin: 0;
    font-size: 12px;
    line-height: 1.55;
    color: #94a3b8;
    max-width: 232px;
    margin-left: auto;
    margin-right: auto;
  }

  .qa-thread {
    padding: 12px 8px 14px;
    margin-bottom: 2px;
    border-radius: 12px;
    border: 1px solid transparent;
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.9);
      border-color: #eef2f7;
      box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .qa-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .qa-row--reply {
    margin-top: 12px;
    &:first-child {
      margin-top: 2px;
    }
  }

  .qa-avatar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 600;
    user-select: none;
    letter-spacing: 0;
  }
  .qa-avatar--root {
    width: 32px;
    height: 32px;
    font-size: 13px;
    margin-top: 2px;
    color: #3d4f5f;
    background: linear-gradient(145deg, #f1f5f9 0%, #e2e8f0 100%);
    box-shadow:
      0 0 0 2px #fff,
      0 0 0 3px rgba(148, 163, 184, 0.35),
      0 2px 6px rgba(15, 23, 42, 0.06);
  }
  .qa-avatar--reply {
    width: 26px;
    height: 26px;
    font-size: 11px;
    margin-top: 2px;
    color: #9d4b63;
    background: linear-gradient(145deg, #fff5f7 0%, #fce8ed 100%);
    box-shadow:
      0 0 0 2px #fff,
      0 0 0 3px rgba(251, 113, 153, 0.22),
      0 2px 5px rgba(15, 23, 42, 0.05);
  }

  .qa-body {
    flex: 1;
    min-width: 0;
    padding-top: 1px;
  }
  .qa-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 2px;
  }
  .qa-head-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
  }
  .qa-nick {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.01em;
  }
  .qa-nick--student {
    color: $primary-dark;
  }
  .qa-nick--teacher {
    color: #d44d7a;
  }
  .qa-badge-lv {
    display: inline-block;
    padding: 1px 6px;
    font-size: 10px;
    font-weight: 700;
    line-height: 15px;
    border-radius: 4px;
    vertical-align: middle;
  }
  .qa-badge-lv--stu {
    color: #c2410c;
    background: linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%);
    border: 1px solid rgba(251, 146, 60, 0.45);
  }
  .qa-badge-lv--teacher {
    color: #0369a1;
    background: linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%);
    border: 1px solid rgba(56, 189, 248, 0.45);
  }

  .qa-content {
    margin: 4px 0 0 0;
    font-size: 13px;
    color: #1e293b;
    line-height: 1.62;
    word-break: break-word;
  }

  .qa-time {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 11px;
    color: #94a3b8;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.01em;
  }

  /* 与主贴正文左缘对齐：头像 32px + 间距 8px */
  .qa-reply-wrap {
    margin-top: 10px;
    padding-left: 40px;
  }

  .qa-compose {
    display: flex;
    align-items: stretch;
    gap: 10px;
    flex-shrink: 0;
    padding: 12px 4px 14px;
    margin-top: auto;
    border-top: 1px solid #e8edf3;
    background: #fff;
    box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.05);
  }
  .qa-compose-inp {
    flex: 1;
    min-width: 0;
  }
  .qa-compose-btn {
    flex-shrink: 0;
    padding-left: 18px;
    padding-right: 18px;
    border-radius: 10px;
    font-weight: 600;
  }

  ::v-deep .qa-compose-inp .el-input__inner {
    border-radius: 10px;
    border-color: #e2e8f0;
    background: #f8fafc;
    font-size: 13px;
    transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
    &:hover {
      background: #fff;
      border-color: #cbd5e1;
    }
    &:focus {
      background: #fff;
      border-color: rgba($primary-dark, 0.45);
      box-shadow: 0 0 0 3px rgba($primary-dark, 0.1);
    }
  }
  ::v-deep .qa-compose-btn.el-button--primary {
    background: linear-gradient(180deg, lighten($primary-dark, 6%) 0%, $primary-dark 100%);
    border: none;
    box-shadow: 0 2px 8px rgba($primary-dark, 0.28);
    &:hover {
      background: linear-gradient(180deg, lighten($primary-dark, 10%) 0%, lighten($primary-dark, 3%) 100%);
    }
  }
}

.chapter {
  margin-bottom: 8px;
  &:last-child { margin-bottom: 0; }
}

.chapter .chapter-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  background: #f5f5f5;
  border-radius: 6px;
  box-sizing: border-box;
  transition: background-color 0.2s;
  &:hover { background: #efefef; }
  .chapter-title {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .chapter-no {
    flex-shrink: 0;
    font-weight: 500;
  }
  .chapter-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chapter-arrow {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    .arrow {
      width: 12px;
      height: 7px;
      opacity: 0.45;
      transition: transform 0.2s;
    }
    &.open .arrow { transform: rotate(180deg); }
  }
}

.lessons {
  position: relative;
  padding: 12px 0 4px 8px;
  &::before {
    content: '';
    position: absolute;
    left: 22px;
    top: 22px;
    bottom: 22px;
    width: 1px;
    background: #e5e5e5;
  }
}

.lesson {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0 8px 4px;
  font-size: 13px;
  line-height: 1.5;
  cursor: pointer;
  transition: color 0.2s;
  .lesson-icon {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    img {
      display: block;
      width: 20px;
      height: 20px;
    }
  }
  .lesson-name {
    flex: 1;
    min-width: 0;
    color: #333;
    word-break: break-all;
  }
  &:hover .lesson-name { color: $primary-dark; }
  &.active .lesson-name {
    color: #1687de;
    font-weight: 500;
  }
}

.paper-area { padding: 8px 30px 24px; }
.paper-list { list-style: none; padding: 0; margin: 0; }
.paper-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;

  &:last-child { border-bottom: none; }

  .paper-info {
    flex: 1;
    min-width: 0;
    padding-right: 24px;
  }

  .paper-name {
    margin: 0 0 12px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
  }

  .paper-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 48px;
    font-size: 14px;
    line-height: 1.5;
  }

  .paper-meta-item {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }

  .meta-label { color: #999; }
  .meta-value { color: #666; }

  .meta-value--link {
    color: #666;
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
    &:hover { color: $primary-dark; }
  }
}

.paper-actions {
  flex-shrink: 0;
}

.paper-btn {
  display: inline-block;
  min-width: 74px;
  border-radius: 37px;
  background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
  color: #fff;
  font-size: 13px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  text-decoration: none;
  border: none;
  transition: background 0.2s;
  white-space: nowrap;

  &:hover { background: $primary; }
  &.outline {
    background: #fff;
    color: $primary-dark;
    border: 1px solid $primary-dark;
    &:hover { background: $primary-light; }
  }
  &.ing{
    background: #0168B7;
  }
}

.confirm-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.45); z-index: 300;
  display: flex; align-items: center; justify-content: center;
}
.confirm-box {
  background: #fff; border-radius: 14px; width: 360px; padding: 32px 28px 24px; text-align: center;
  box-shadow: 0 12px 40px rgba(0,0,0,.15);
}
.confirm-icon { width: 52px; height: 52px; border-radius: 50%; margin: 0 auto 16px; display: flex; align-items: center; justify-content: center; font-size: 26px; &.warn { background: #fef0f0; color: #f56c6c; } }
.confirm-title { font-size: 16px; font-weight: bold; color: #333; margin-bottom: 8px; }
.confirm-desc { font-size: 14px; color: #999; line-height: 1.6; margin-bottom: 24px; }
.confirm-actions {
  display: flex; gap: 12px; justify-content: center;
  .btn { flex: 1; padding: 10px 0; border-radius: 22px; font-size: 14px; cursor: pointer; transition: all .2s; border: none; }
  .btn-cancel { background: #f5f5f5; color: #666; &:hover { background: #eee; } }
  .btn-danger { background: #f56c6c; color: #fff; &:hover { background: #e84d4d; } }
}

.mode-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.45); z-index: 200;
  display: flex; align-items: center; justify-content: center;
}
.mode-dialog {
  background: #fff;
  border-radius: 10px;
  width: 460px;
  padding: 30px 30px 40px 30px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  animation: popIn 0.25s ease;

  .mode-dialog-header {
    position: relative;
    margin-bottom: 30px;
    padding: 0 30px;
  }

  .md-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    text-align: center;
    line-height: 1.4;
  }

  .md-close {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    font-size: 22px;
    color: #999;
    cursor: pointer;
    line-height: 1;
    padding: 0 4px;

    &:hover {
      color: #333;
    }
  }

  .md-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 50px;
  }

  .md-opt {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
      border-color: #b3d4ec;
    }

    &.active {
      border-color: #4084ff;
      background: #f0f7ff;
    }

    .md-icon-img {
      width: 44px;
      height: 44px;
      flex-shrink: 0;
      object-fit: contain;
    }

    &:not(.active) .md-icon-img {
      filter: grayscale(1);
      opacity: 0.85;
    }

    .md-text {
      flex: 1;
      min-width: 0;
      text-align: left;
    }

    .md-name {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 6px;
      line-height: 1.3;
    }

    .md-desc {
      font-size: 13px;
      color: #999;
      line-height: 1.5;
    }
  }

  .md-actions {
    display: flex;
    gap: 30px;
    justify-content: center;
  }

  .md-btn {
    flex: 1;
    max-width: 90px;
    height: 30px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    outline: none;
  }

  .md-btn-cancel {
    background: #fff;
    color: #4084ff;
    border: 1px solid #4084ff;

    &:hover {
      background: #f0f7ff;
    }
  }

  .md-btn-confirm {
    background: linear-gradient(90deg, #1687de 0%, #4084ff 100%);
    color: #fff;

    &:hover {
      opacity: 0.92;
    }
  }
}

@keyframes popIn {
  from { opacity: 0; transform: scale(.9); }
  to { opacity: 1; transform: scale(1); }
}

.link-btn{
  text-decoration: underline;
}

.page-header {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 30px;

  .page-title {
    padding: 0;

    .title-bar {
      display: inline-block;
      width: 6px;
      height: 18px;
      background: linear-gradient(90deg, #1687DE 0%, #4084FF 100%);
      border-radius: 0 !important;
      margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }

  .back-link {
    font-size: 14px;
    color: #767676;
    cursor: pointer;
    text-decoration: none;

    .el-icon-back {
      margin-right: 4px;
    }
  }
}
</style>
